import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = () => {
  return (
    <Helmet>
      {/* Metadata */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <meta name="description" content="PayFusionx" />

      {/* Favicon */}
      <link rel="icon" href="/dilliPay.ico" />
      <link rel="apple-touch-icon" href="/dilliPay.ico" />

      {/* Web App Manifest */}
      <link rel="manifest" href="/manifest.json" />

      {/* Page Title */}
      <title>{process.env.REACT_APP_TITLE || "DilliPay"}</title>
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/logo192.png" />
      <link rel="manifest" href="/manifest.json" />
      {/* Bootstrap JS */}

      <script
        type="text/javascript"
        async
        charSet="utf-8"
        src="https://www.gstatic.com/recaptcha/releases/bUO1BXI8H9PgjAPSW9hwuSeI/recaptcha__en.js"
        crossOrigin="anonymous"
        integrity="sha384-W6vGSa1gNU2JYZ4aYa4y4W3SgdiTlWqPltQiHH1/PEEh6w3sEdnuACkbWBJN1UBJ"
      ></script>
      <script src="https://code.iconify.design/3/3.0.1/iconify.min.js"></script>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
      />

      {/* Allow Google Fonts (for MUI Typography) */}
      <link
        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
        rel="stylesheet"
      />

      {/* FontAwesome */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css"
        integrity="sha384-KyZXEAg3QhqLMpG8r+Knujsl5+5hb7ae1F6H30/fDfJg6j8h6L5U5u5Y5t5E1g2l2"
        crossOrigin="anonymous"
      />

      {/* Google Fonts (Optional) */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap"
        rel="stylesheet"
      />

      {/* jQuery */}
      <script
        src="https://code.jquery.com/jquery-3.6.0.min.js"
        integrity="sha384-KyZXEAg3QhqLMpG8r+Knujsl5+5hb7ae1F6H30/fDfJg6j8h6L5U5u5Y5t5E1g2l2"
        crossOrigin="anonymous"
      ></script>

      {/* Slick Carousel */}
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css"
      />

      {/* Slick Carousel JS */}
      <script
        type="text/javascript"
        src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js"
      ></script>

      {/* Chart.js */}
      <script
        src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.2.0/chart.umd.min.js"
        integrity="sha384-g9Gfw6Cwo1x2BdU87I5Bsd/6FjvFyxzq/FYz83w5XisA/GzDlEymfHCmNBxN6C+U"
        crossOrigin="anonymous"
      ></script>

      {/* Google reCAPTCHA */}
      <script
        src="https://www.google.com/recaptcha/api.js"
        async
        defer
      ></script>

      {/* Firebase */}
      <script
        type="module"
        src="https://www.gstatic.com/firebasejs/10.2.0/firebase-app.js"
      ></script>
      <script
        type="module"
        src="https://www.gstatic.com/firebasejs/10.2.0/firebase-auth.js"
      ></script>

      {/* Crisp Chat SDK */}
      {/* <script type="text/javascript">
        {`
          window.$crisp=[];
          window.CRISP_WEBSITE_ID="YOUR_CRISP_WEBSITE_ID";
          (function(){
            d=document;
            s=d.createElement("script");
            s.src="https://client.crisp.chat/l.js";
            s.async=1;
            d.getElementsByTagName("head")[0].appendChild(s);
          })();
        `}
      </script> */}

      {/* SweetAlert2 */}
      <script
        src="https://cdn.jsdelivr.net/npm/sweetalert2@11"
        integrity="sha384-oQJpRfUdGuKzYYD1PlC1uCVvOQo3EUptz5PKL8Wq2x7O5MAl9U2pG7U7a12f3M3"
        crossOrigin="anonymous"
      ></script>
    </Helmet>
  );
};

export default SEO;
